import type { ReactElement } from 'react';
import type { NavLinkProps } from 'react-router-dom';

import { NavLink } from 'react-router-dom';

import { Box, Badge, Stack, alpha, styled, Typography } from '@mui/material';

const StyledLink = styled(NavLink)(({ theme }) => ({
  display: 'block',
  backgroundColor: theme.palette.background.paper,
  padding: '8px',
  borderRadius: '12px',
  textDecoration: 'none',
  transition: 'background-color 0.25s ease, color 0.25s ease',

  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
  },

  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      backgroundColor: theme.palette.gray.contrastText,
      '& .MuiTypography-root': {
        color: 'white',
      },
      '& .MuiSvgIcon-root': {
        color: 'white',
      },
    },
  },

  '@media (hover: none) and (pointer: coarse)': {
    '&:active': {
      backgroundColor: theme.palette.gray.contrastText,
      '& .MuiTypography-root': {
        color: 'white',
      },
      '& .MuiSvgIcon-root': {
        color: 'white',
      },
    },
  },
}));

interface Props extends NavLinkProps {
  icon: ReactElement;
  title: string;
  subtitle: string;
  badge?: boolean;
  iconBgColor?: string;
}

export const ButtonLink = ({
  title,
  subtitle,
  icon,
  badge = false,
  iconBgColor,
  ...props
}: Props) => (
  <StyledLink {...props}>
    <Stack direction="row" gap="16px" alignItems="center">
      <Badge color="error" variant="dot" invisible={!badge}>
        <Box
          height="36px"
          width="36px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          borderRadius={1}
          sx={{
            backgroundColor: alpha(iconBgColor || '#404040', 0.1),
          }}
        >
          {icon}
        </Box>
      </Badge>
      <Stack>
        <Typography color="text.primary" fontSize={13} fontWeight={400}>
          {title}
        </Typography>
        {/* <Typography color="text.secondary" fontSize="13px" lineHeight="16px">
          {subtitle}
        </Typography> */}
      </Stack>
    </Stack>
  </StyledLink>
);
